<template>
  <div class="team-notifications-container">
    <team-icon :team="singleTeam" class="team-icon" />
    <div class="team-name">
      {{ singleTeam.name }}
    </div>
    <p v-if="description" class="setting-description">
      {{ description }}
    </p>

    <div class="content">
      <p class="description">
        {{ $t('notifyMeAbout') }}
      </p>
      <toggle :name="$t('teamMembers')" :value="pushNotifications" class="main-toggle" @toggled="toggleAll" />

      <transition name="slide">
        <div v-if="pushNotifications" class="secondary-toggles">
          <toggle
            v-for="el in notificationArray"
            :key="el.key"
            :team-id="singleTeam.teamId"
            :name="el.name"
            :value="el.value"
            class="toggle"
            @toggled="saveNotificationKey(el)"
          />
        </div>
      </transition>

      <toggle
        :team-id="singleTeam.teamId"
        :value="remindedAboutWorkingSchedule"
        :name="$t('deadlineReminder')"
        class="main-toggle"
        @toggled="saveRemindMeAboutSchedule"
      />
    </div>
  </div>
</template>

<script>
import Toggle from '@/components/UI/Toggle'
import TeamIcon from '@/components/Team/TeamIcon'
import Constants from '@/components/Constants'
import ParseFunctions from '@/components/ParseFunctions'

export default {
  name: 'TeamWorkNotificationToggles',
  components: {
    Toggle,
    TeamIcon,
  },
  mixins: [Constants, ParseFunctions],
  props: {
    singleTeam: {
      default: undefined,
      type: Object,
    },
    description: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      notificationArray: [],
      pushNotifications: false,
      remindedAboutWorkingSchedule: false,
    }
  },
  created() {
    this.remindedAboutWorkingSchedule = false
    if (!this.singleTeam.notifyOnAllChannelsAbout) {
      for (let i = 0; i < this.teamNotificationKeys().length; i++) {
        this.notificationArray.push({
          key: this.teamNotificationKeys()[i].key,
          name: this.teamNotificationKeys()[i].name,
          value: false,
        })
      }
    } else {
      for (let i = 0; i < this.teamNotificationKeys().length; i++) {
        this.notificationArray.push({
          key: this.teamNotificationKeys()[i].key,
          name: this.teamNotificationKeys()[i].name,
          value: this.singleTeam.notifyOnAllChannelsAbout.includes(this.teamNotificationKeys()[i].key),
        })
        if (this.singleTeam.notifyOnAllChannelsAbout.includes(this.teamNotificationKeys()[i].key)) {
          this.pushNotifications = true
        }
      }
      if (this.singleTeam.notifyOnAllChannelsAbout.includes('me-missed-deadline')) {
        this.remindedAboutWorkingSchedule = true
      }
    }
  },
  methods: {
    async saveNotificationKey(el) {
      el.value = !el.value
      if (el.value && this.pushNotifications === false) {
        this.pushNotifications = true
      }
      let notificationToSave = {}
      for (let i = 0; i < this.notificationArray.length; i++) {
        notificationToSave[this.notificationArray[i].key] = this.notificationArray[i].value
      }

      await this.setTeamMemberNotificationSettings(this.singleTeam.teamId, notificationToSave)
    },

    async saveRemindMeAboutSchedule() {
      this.remindedAboutWorkingSchedule = !this.remindedAboutWorkingSchedule
      await this.setTeamMemberNotificationSettings(this.singleTeam.teamId, { 'me-missed-deadline': this.remindedAboutWorkingSchedule })
    },

    async toggleAll() {
      this.$emit('lock-scroll')
      this.pushNotifications = !this.pushNotifications
      setTimeout(
        function () {
          this.$emit('lock-scroll')
        }.bind(this),
        400,
      )

      let notificationToSave = {}
      for (let i = 0; i < this.notificationArray.length; i++) {
        this.notificationArray[i].value = this.pushNotifications
        notificationToSave[this.notificationArray[i].key] = this.pushNotifications
      }

      await this.setUserSetting('push-notifications', this.pushNotifications)
      await this.setTeamMemberNotificationSettings(this.singleTeam.teamId, notificationToSave)
    },
  },
}
</script>

<style scoped lang="scss">
.team-notifications-container {
  display: grid;
  grid-template-columns: 30px auto;
  column-gap: 20px;
  grid-template-rows: 30px auto 24px auto;
  align-items: center;
  // grid-row-gap: 8px;
  // margin-top: 30px;
  position: relative;
  @include respond-below(sm) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}
.team-icon {
  transform: scale(1.4);
  transform-origin: center left;
  @include respond-below(sm) {
    margin-bottom: 18px;
  }
}
.team-name {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.2px;
  font-family: $bold;
  vertical-align: middle;
  grid-column-start: 2;
}

.description {
  font-size: $font-size-caption;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: $black;
  margin-top: 3px;
  margin-bottom: 12px;
}
.setting-description {
  grid-column: 2;
  grid-row: 2;
  color: $amethyst;
  @include respond-below(sm) {
    margin-top: 14px;
    margin-bottom: 36px;
  }
}
.content {
  grid-column: 2;
  grid-row: 4;
}

.main-toggle {
  margin-bottom: 8px;
}
.secondary-toggles {
  grid-column: span 2;
  display: grid;
  grid-column-gap: 60px;
  margin-left: 40px;
  margin-bottom: 18px;
  p {
    grid-column: span 2;
  }
  .toggle {
    grid-column-end: 2;
  }
  @include respond-below(xs) {
    display: flex;
    flex-direction: column;
  }
}
</style>
